import CryptoJS from 'crypto-js';
import moment from 'moment/min/moment-with-locales';

// const SIGNATURE_KEY = import.meta.env.VITE_X_CLIENT_SIGNATURE_KEY;
export const makeSignatureKey = (signatureKey: string) => {
  const momentUnix = moment().valueOf();
  const date = moment(momentUnix).toDate();
  const utcDateString = `${date.getUTCFullYear()}-${zeroFill(date.getUTCMonth() + 1, 2)}-${zeroFill(
    date.getUTCDate(),
    2
  )} ${zeroFill(date.getUTCHours(), 2)}:${zeroFill(date.getUTCMinutes(), 2)}`;
  const signBytes = CryptoJS.HmacSHA256(utcDateString, signatureKey);
  const signHex = CryptoJS.enc.Hex.stringify(signBytes);
  return signHex;
};

const zeroFill = (value: any, len: number) => '0'.repeat(len - value.toString().length) + value;
